// extracted by mini-css-extract-plugin
export default {"backdrop":"DropdownMenu_backdrop__Er9nh","modal":"DropdownMenu_modal__C38k1","dropdownFade":"DropdownMenu_dropdownFade__ZP5q9"};